import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import POSCheckIn from "../pages/pos-checkin/page";
import POSCheckout from "../pages/pos-checkout/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pos-checkin",
    element: <POSCheckIn />,
  },
  {
    path: "/pos-checkout",
    element: <POSCheckout />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
